import Session from '../auth/Session';

const AdminFunctions = {
    isAdminAsync: async function() {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/IsAdminAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    handleAdminUser: async function(isAdmin, adminFunction, nonAdminFunction) {
        if(isAdmin) {
            if(adminFunction){ adminFunction(); };            
        } else {
            if(nonAdminFunction){ nonAdminFunction(); };            
        }
    },    
    getRoleIdByName: async function(name) {        
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetRoleIdByNameAsync?roleName=${name}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data.id;
    },
    isRole: async function (name) {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/IsRoleAsync?roleName=${name}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    }
}

export default AdminFunctions;